import { Button, Layout, Modal } from 'antd'
import BrandsForm from 'elements/Brands/BrandsForm'
import FooterButtons from 'elements/Buttons/FooterButtons'
import CustomTable from 'elements/Table/CustomTable'
import React from 'react'
import { Link } from 'react-router-dom'

function Brands(props) {
  const {
    list,
    fetch,
    fetching,
    onShow,
    visible,
    onCancel,
    remove,
    removing,
    submit,
    update,
    submitting,
    isNew,
    formRef,
  } = props

  const columns = [
    {
      Header: 'Brand',
      accessor: 'name',
      Cell: ({ value, original }) => <a onClick={() => onShow(original, 'edit')}>{value}</a>,
    },
    { Header: 'url', accessor: 'url' },
    { Header: 'logo', accessor: 'logo' },
    { Header: 'facebook', accessor: 'facebook' },
  ]

  return (
    <>
      <Modal
        visible={visible}
        title={'Brands'}
        onCancel={onCancel}
        width={'95%'}
        destroyOnClose={true}
        footer={
          <FooterButtons
            remove={remove}
            removing={removing}
            submit={submit}
            update={update}
            submitting={submitting}
            title={'Brands'}
            isNew={isNew}
            isEdit={!isNew}
          />
        }>
        <BrandsForm ref={formRef} />
      </Modal>
      <CustomTable
        data={list}
        defaultPageSize={20}
        isFilterable={true}
        fetching={fetching}
        fetch={fetch}
        columns={columns}
        CreateButton={() => (
          <Button type={'primary'} size="small" icon={'plus'} onClick={onShow}>
            New
          </Button>
        )}
        defaultSorted={[
          {
            id: 'code',
            desc: true,
          },
        ]}
      />
    </>
  )
}

export default Brands
